import { IToken } from "src/services/types";


export const setToken = (token: IToken): void => {
    localStorage.setItem("aToken", JSON.stringify(token));
};

export const getToken = (): string => {
    let token: IToken = (null as unknown) as IToken;
    try {
        token = JSON.parse(localStorage.getItem("aToken") || "");
    } catch (error) {
        token = (null as unknown) as IToken;
    }
    return token ? `${token.tokenType} ${token.accessToken}` : "no-token";
};

export const removeDataLocalStorage = (): void => {
    localStorage.removeItem("aToken");
};